/* unplugin-vue-components disabled */import { render } from "./source-type.vue?vue&type=template&id=39e2605e&scoped=true"
import script from "./source-type.vue?vue&type=script&lang=js"
export * from "./source-type.vue?vue&type=script&lang=js"

import "./source-type.vue?vue&type=style&index=0&id=39e2605e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e2605e"],['__file',"src/components/sources-v2/source-type.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39e2605e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39e2605e', __exports__)) {
    api.reload('39e2605e', __exports__)
  }
  
  module.hot.accept("./source-type.vue?vue&type=template&id=39e2605e&scoped=true", () => {
    api.rerender('39e2605e', render)
  })

}


export default __exports__